import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useHistory, useLocation } from 'react-router-dom';

// Components
import Alert from '../Alert';
import ModalConfirm from '../ModalConfirm';
import CookiePolicyPopup from '../CookiePolicyPopup';

// Config
import config from '../../config';

// Styles
import styles from './Layout.styl';

import HeaderDesktop from '../Header/DesktopView';
import HeaderMobile from '../Header/MobileView';
import FooterDesktop from '../Footer/DesktopView';
import FooterMobile from '../Footer/MobileView';
import DeliveryTypeSwitcher from '../DeliveryTypeSwitcher/DesktopView';
import AddressSelector from '../AddressSelector/DesktopView';
import RestaurantSelector from '../RestaurantSelector/DesktopView';
import Modal from '../Modal';
import { getRoute, paths } from '../../entry/routes';

const cx = classNames.bind(styles);

export default function Layout(props) {
  const history = useHistory();
  const location = useLocation();

  const { children, simple, theme, isLanding } = props;
  const isRealPhone = useSelector(state => state.responsive.isRealPhone);
  const Header = isRealPhone ? HeaderMobile : HeaderDesktop;
  const Footer = isRealPhone ? FooterMobile : FooterDesktop;
  const deliveryType = useSelector(state => state.order.checkout.deliveryType);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  useEffect(() => {
    // Если мобильный
    if (isRealPhone) {
      const storedCheckout = localStorage.getItem('checkout');
      let needRedirect = true;

      if (storedCheckout) {
        try {
          const parsed = JSON.parse(storedCheckout);
          const type = parsed?.value?.deliveryType;

          if (type === 'delivery' && parsed?.value?.deliveryAddress?.address_in_line) {
            needRedirect = false;
          } else if (type === 'pickup' && parsed?.value?.pickupRestaurant?.address) {
            needRedirect = false;
          }
        } catch (e) {
          console.error('Checkout parse error:', e);
        }
      }

      if (needRedirect) {
        history.push(getRoute(paths.address)); // редиректим
      }

      return; // для мобильной версии — выходим из эффекта
    }

    // Логика для десктопа и планшета
    const storedCheckout = localStorage.getItem('checkout');
    try {
      if (storedCheckout) {
        const parsed = JSON.parse(storedCheckout);
        const type = parsed?.value?.deliveryType;

        if (type === 'delivery') {
          const address = parsed?.value?.deliveryAddress?.address_in_line;
          setIsAddressModalOpen(!address);
        } else if (type === 'pickup') {
          const restaurant = parsed?.value?.pickupRestaurant?.address;
          setIsAddressModalOpen(!restaurant);
        } else {
          setIsAddressModalOpen(true);
        }
      } else {
        setIsAddressModalOpen(true);
      }
    } catch (e) {
      console.error('Checkout parse error:', e);
      setIsAddressModalOpen(true);
    }
  }, [isRealPhone, location.pathname]);

  const handleOnAddressModalClose = () => {
    setIsAddressModalOpen(false);
  };
  return (
    <div
      className={cx('Layout', `Layout_theme_${theme}`, { Layout_simple: isRealPhone && simple })}
    >
      <Header className={cx('Layout__header')} isLanding={isLanding} />
      <div className={cx('Layout__main')}>{children}</div>
      {!isLanding ? <Footer className={cx('Layout__footer')} /> : null}
      <ModalConfirm />
      <Alert />
      <Modal
        className={cx('AddressButton__modal')}
        specialClassName={cx('AddressButton__modalRoot')}
        isOpen={isAddressModalOpen}
        onClose={()=>{}}
      >
        <DeliveryTypeSwitcher className={cx('AddressButton__types')} />
        {deliveryType === 'delivery' && (
          <AddressSelector onSuccessCallback={handleOnAddressModalClose} modalMode={true} />
        )}
        {deliveryType === 'pickup' && (
          <RestaurantSelector onSuccessCallback={handleOnAddressModalClose} />
        )}
      </Modal>
      {(config.legal === 'pl' || config.legal === 'de') && <CookiePolicyPopup />}
    </div>
  );
}

Layout.defaultProps = {
  simple: true,
  theme: 'primary',
  isLanding: false,
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  simple: PropTypes.bool,
  theme: PropTypes.oneOf(['primary', 'secondary']),
  isLanding: PropTypes.bool,
};
